import { useCallback } from "react";
import { encode } from "querystring";
import { useLocation, useNavigate } from "react-router-dom";

import { urlQueryToObj } from "utils/buildQuery";

export const useLocationQuery = () => {
  const { search } = useLocation();
  return urlQueryToObj(search);
};

export const useLocationQueryValue = (key) => useLocationQuery()[key];

export const useLocationQuerySet = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return useCallback(
    (query) => {
      navigate(`${pathname}${query && `?${encode(query)}`}`);
    },
    [pathname, navigate]
  );
};

export const useLocationQueryAdd = () => {
  const obj = useLocationQuery();
  const setQuery = useLocationQuerySet();
  return useCallback(
    (key, value) => {
      if (value) {
        obj[key] = value;
      } else {
        delete obj[key];
      }
      setQuery(obj);
    },
    [obj, setQuery]
  );
};
